import runWithTimeout from './runWithTimeout';

const OAUTH_BASE_URL = 'https://login.windows.net/common/oauth2/authorize';
const TIMEOUT = 90 * 1000;

export default function runWithOauthIframe<T>(
    origin: string,
    redirect: string,
    clientId: string,
    callback: (contentWindow: Window) => Promise<T>
): Promise<T> {
    if (!origin || (clientId && !redirect)) {
        return Promise.resolve<T>(null);
    }
    const url = clientId ? buildOauthUrl(origin, redirect, clientId) : origin;
    let iframe: HTMLIFrameElement;

    return runWithTimeout<T>(
        resolve => {
            iframe = document.createElement('iframe');
            // We mark the iframe with sandbox to prevent top redirects
            iframe.setAttribute('sandbox', 'allow-scripts allow-forms allow-same-origin');
            iframe.onload = async () => {
                const result = await callback(iframe.contentWindow);
                resolve(result);
            };
            iframe.src = url;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        },
        () => {
            if (iframe.parentNode) {
                iframe.parentNode.removeChild(iframe);
            }
        },
        TIMEOUT
    );
}

function buildOauthUrl(origin: string, redirect: string, clientId: string) {
    const url = new URL(origin);
    const resource = `${url.protocol}//${url.host}/`;
    const params = {
        response_type: 'token',
        prompt: 'none',
        client_id: clientId,
        resource: resource,
        redirect_uri: redirect,
    };

    return `${OAUTH_BASE_URL}?${Object.keys(params)
        .map(key => `${key}=${encodeURIComponent(params[key])}`)
        .join('&')}`;
}
